const API_BASE_URL = process.env.REACT_APP_API_URL?.replace(/\/$/, '') || 'http://localhost:5001';

export const fetchRestaurantMenuData = async (restaurantName) => {
  if (!restaurantName) {
    throw new Error('Restaurant name is required to fetch menu.');
  }

  const endpoint = `${API_BASE_URL}/api/restaurant-menu?restaurant=${encodeURIComponent(restaurantName)}`;
  const response = await fetch(endpoint);

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    const message = errorBody?.error || 'Failed to load menu.';
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  return response.json();
};

export const getMenuApiBaseUrl = () => API_BASE_URL;
